import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import SectionTitle from "../common/SectionTitle";
import QuarriesCard from "./QuarriesCard";

function QuarriesBursaOrhaneli() {
  const { t } = useTranslation();

  return (
    <section className="p-5 text-center ocaklarimiz" id="bursaorhaneli">
      <div className="container" style={{ marginTop: "5rem" }}>
        <SectionTitle title={t("BURSA BURÇ ORHANELİ")} />
      </div>

      <div className="row row-cols-1 row-cols-md-3 g-4">
        <div className="col mb-4">
          <QuarriesCard
            link="/lightemperador"
            title={t("Light Emperador")}
            picture="/assets/img/Light Emperador.webp"
            company="Burç Madencilik Ltd. Şti."
          />
        </div>
      </div>
    </section>
  );
}

export default QuarriesBursaOrhaneli;